<template lang="pug">
  .c-popup(v-show="param.popup" @click="param.popup = false")
    .c-popup__operate.col-24.color-white.flexD.flexDirectionRow.justifySpaceBetween.alignItemsCenter.m-width-90.m-maxWidthNone(@click="stopPropagation($event)")
      .width10EM
      .flexD.flexDirectionRow.alignItemsCenter.font-title
        .width2EM.textAlignCenter
          i.fa.fa-arrow-left.cursorPointer(@click="prevPage" v-if="param.index > 0")
        .width2EM.textAlignCenter
          i.fa.fa-close.cursorPointer(@click="param.popup = false")
        .width2EM.textAlignCenter
          i.fa.fa-arrow-right.cursorPointer(@click="nextPage" v-if="param.index < arr.length - 1")
      a.cursorPointer.font-section.width10EM.color-white.textDecorationNone(:href="arr[param.index].download" target="_blank" download)
        i.fa.fa-download.lineHeight2EM(style="font-size: 1.5em")
    .c-popup__content.m-width-90.m-maxWidthNone(@click="stopPropagation($event)")
      .col-24.bgColor-white.flexD.flexDirectionColumn
        .col-24.flexD.flexWrap.flexDirectionRow.alignItemsCenter.justifySpaceBetween
          .col-10.flexD.justifyCenter.m-width-100.m-margin-bottom-1em
            .col-12.m-width-30.msFlexNegative
              img.block.col-24(:src="arr[param.index].image")
          .col-12.m-width-100
            .font-title-middle.fontBold.color-font-deepGary.m-margin-bottom-1em {{ arr[param.index].title }}
            .col-24
              .col-24.flexD.justifySpaceBetween(v-for="(n, m) in arr[param.index].info" :key="`${m}_info`")
                .font-section.col-6.textAlignLeft.color-font-deepGary {{ n.label }}
                .font-section.col-18.textAlignRight.color-font-gary(:class="n.className") {{ n.content }}
            .l-margin-top-1em
              .col-24.flexD.justifySpaceBetween(v-for="(n, m) in arr[param.index].alcohol" :key="`${m}_alcohol`")
                .font-section.col-6.textAlignLeft.color-font-deepGary {{ n.label }}
                .font-section.col-18.textAlignRight.color-font-gary(:class="n.className") {{ n.content }}
        .col-24.l-margin-top-1em
          .col-24.flexD.justifySpaceBetween.m-flexWrap.m-margin-bottom-1em(v-for="(n, m) in arr[param.index].des" :key="`${m}_des`")
            .font-section.col-6.textAlignLeft.color-font-deepGary.m-width-100 {{ n.label }}
            .font-section.col-18.textAlignLeft.color-font-gary.m-width-100(:class="n.className") {{ n.content }}

</template>

<script>
  export default {
    name: 'popupStigler',
    props: ['content'],
    data(){
      return{
        param: {
          popup: false,
          index: 0
        },
        pdf: "./wibo_pdf.pdf",
        arr: [
          {
            title: this.$t('stigler_popup.item_1.title'),
            image: require('@/assets/img/stigler/704.png'),
            download: './doc/葡萄酒彩页.pdf',
            info: [
              { label: this.$t('stigler_popup.label_1'), content: this.$t('stigler_popup.item_1.content_1'), className: "" },
              { label: this.$t('stigler_popup.label_2'), content: this.$t('stigler_popup.item_1.content_2'), className: "" },
              { label: this.$t('stigler_popup.label_3'), content: this.$t('stigler_popup.item_1.content_3'), className: "" },
              { label: this.$t('stigler_popup.label_4'), content: this.$t('stigler_popup.item_1.content_4'), className: "" },
              { label: this.$t('stigler_popup.label_5'), content: this.$t('stigler_popup.item_1.content_5'), className: "" },
              { label: this.$t('stigler_popup.label_6'), content: this.$t('stigler_popup.item_1.content_6'), className: "" },
              { label: this.$t('stigler_popup.label_7'), content: this.$t('stigler_popup.item_1.content_7'), className: "" },
            ],
            alcohol:[
              { label: this.$t('stigler_popup.label_8'), content: this.$t('stigler_popup.item_1.content_8'), className: "" },
              { label: this.$t('stigler_popup.label_9'), content: this.$t('stigler_popup.item_1.content_9'), className: "" },
              { label: this.$t('stigler_popup.label_10'), content: this.$t('stigler_popup.item_1.content_10'), className: "" },
            ],
            des: [
              { label: this.$t('stigler_popup.label_11'), content: this.$t('stigler_popup.item_1.content_11'), className: "" },
              { label: this.$t('stigler_popup.label_12'), content: this.$t('stigler_popup.item_1.content_12'), className: "" },
              { label: this.$t('stigler_popup.label_13'), content: this.$t('stigler_popup.item_1.content_13'), className: "" },
            ]
          },
          {
            title: this.$t('stigler_popup.item_2.title'),
            image: require('@/assets/img/stigler/204.png'),
            download: './doc/葡萄酒彩页.pdf',
            info: [
              { label: this.$t('stigler_popup.label_1'), content: this.$t('stigler_popup.item_2.content_1'), className: "" },
              { label: this.$t('stigler_popup.label_2'), content: this.$t('stigler_popup.item_2.content_2'), className: "" },
              { label: this.$t('stigler_popup.label_3'), content: this.$t('stigler_popup.item_2.content_3'), className: "" },
              { label: this.$t('stigler_popup.label_4'), content: this.$t('stigler_popup.item_2.content_4'), className: "" },
              { label: this.$t('stigler_popup.label_5'), content: this.$t('stigler_popup.item_2.content_5'), className: "" },
              { label: this.$t('stigler_popup.label_6'), content: this.$t('stigler_popup.item_2.content_6'), className: "" },
              { label: this.$t('stigler_popup.label_7'), content: this.$t('stigler_popup.item_2.content_7'), className: "" },
            ],
            alcohol:[
              { label: this.$t('stigler_popup.label_8'), content: this.$t('stigler_popup.item_2.content_8'), className: "" },
              { label: this.$t('stigler_popup.label_9'), content: this.$t('stigler_popup.item_2.content_9'), className: "" },
              { label: this.$t('stigler_popup.label_10'), content: this.$t('stigler_popup.item_2.content_10'), className: "" },
            ],
            des: [
              { label: this.$t('stigler_popup.label_11'), content: this.$t('stigler_popup.item_2.content_11'), className: "" },
              { label: this.$t('stigler_popup.label_12'), content: this.$t('stigler_popup.item_2.content_12'), className: "" },
              { label: this.$t('stigler_popup.label_13'), content: this.$t('stigler_popup.item_2.content_13'), className: "" },
            ]
          },
          {
            title: this.$t('stigler_popup.item_3.title'),
            image: require('@/assets/img/stigler/711.png'),
            download: './doc/葡萄酒彩页.pdf',
            info: [
              { label: this.$t('stigler_popup.label_1'), content: this.$t('stigler_popup.item_3.content_1'), className: "" },
              { label: this.$t('stigler_popup.label_2'), content: this.$t('stigler_popup.item_3.content_2'), className: "" },
              { label: this.$t('stigler_popup.label_3'), content: this.$t('stigler_popup.item_3.content_3'), className: "" },
              { label: this.$t('stigler_popup.label_4'), content: this.$t('stigler_popup.item_3.content_4'), className: "" },
              { label: this.$t('stigler_popup.label_5'), content: this.$t('stigler_popup.item_3.content_5'), className: "" },
              { label: this.$t('stigler_popup.label_6'), content: this.$t('stigler_popup.item_3.content_6'), className: "" },
              { label: this.$t('stigler_popup.label_7'), content: this.$t('stigler_popup.item_3.content_7'), className: "" },
            ],
            alcohol:[
              { label: this.$t('stigler_popup.label_8'), content: this.$t('stigler_popup.item_3.content_8'), className: "" },
              { label: this.$t('stigler_popup.label_9'), content: this.$t('stigler_popup.item_3.content_9'), className: "" },
              { label: this.$t('stigler_popup.label_10'), content: this.$t('stigler_popup.item_3.content_10'), className: "" },
            ],
            des: [
              { label: this.$t('stigler_popup.label_11'), content: this.$t('stigler_popup.item_3.content_11'), className: "" },
              { label: this.$t('stigler_popup.label_12'), content: this.$t('stigler_popup.item_3.content_12'), className: "" },
              { label: this.$t('stigler_popup.label_13'), content: this.$t('stigler_popup.item_3.content_13'), className: "" },
            ]
          },
          {
            title: this.$t('stigler_popup.item_4.title'),
            image: require('@/assets/img/stigler/804.png'),
            download: './doc/葡萄酒彩页.pdf',
            info: [
              { label: this.$t('stigler_popup.label_1'), content: this.$t('stigler_popup.item_4.content_1'), className: "" },
              { label: this.$t('stigler_popup.label_2'), content: this.$t('stigler_popup.item_4.content_2'), className: "" },
              { label: this.$t('stigler_popup.label_3'), content: this.$t('stigler_popup.item_4.content_3'), className: "" },
              { label: this.$t('stigler_popup.label_4'), content: this.$t('stigler_popup.item_4.content_4'), className: "" },
              { label: this.$t('stigler_popup.label_5'), content: this.$t('stigler_popup.item_4.content_5'), className: "" },
              { label: this.$t('stigler_popup.label_6'), content: this.$t('stigler_popup.item_4.content_6'), className: "" },
              { label: this.$t('stigler_popup.label_7'), content: this.$t('stigler_popup.item_4.content_7'), className: "" },
            ],
            alcohol:[
              { label: this.$t('stigler_popup.label_8'), content: this.$t('stigler_popup.item_4.content_8'), className: "" },
              { label: this.$t('stigler_popup.label_9'), content: this.$t('stigler_popup.item_4.content_9'), className: "" },
              { label: this.$t('stigler_popup.label_10'), content: this.$t('stigler_popup.item_4.content_10'), className: "" },
            ],
            des: [
              { label: this.$t('stigler_popup.label_11'), content: this.$t('stigler_popup.item_4.content_11'), className: "" },
              { label: this.$t('stigler_popup.label_12'), content: this.$t('stigler_popup.item_4.content_12'), className: "" },
              { label: this.$t('stigler_popup.label_13'), content: this.$t('stigler_popup.item_4.content_13'), className: "" },
            ]
          },
          {
            title: this.$t('stigler_popup.item_5.title'),
            image: require('@/assets/img/stigler/807.png'),
            download: './doc/葡萄酒彩页.pdf',
            info: [
              { label: this.$t('stigler_popup.label_1'), content: this.$t('stigler_popup.item_5.content_1'), className: "" },
              { label: this.$t('stigler_popup.label_2'), content: this.$t('stigler_popup.item_5.content_2'), className: "" },
              { label: this.$t('stigler_popup.label_3'), content: this.$t('stigler_popup.item_5.content_3'), className: "" },
              { label: this.$t('stigler_popup.label_4'), content: this.$t('stigler_popup.item_5.content_4'), className: "" },
              { label: this.$t('stigler_popup.label_5'), content: this.$t('stigler_popup.item_5.content_5'), className: "" },
              { label: this.$t('stigler_popup.label_6'), content: this.$t('stigler_popup.item_5.content_6'), className: "" },
              { label: this.$t('stigler_popup.label_7'), content: this.$t('stigler_popup.item_5.content_7'), className: "" },
            ],
            alcohol:[
              { label: this.$t('stigler_popup.label_8'), content: this.$t('stigler_popup.item_5.content_8'), className: "" },
              { label: this.$t('stigler_popup.label_9'), content: this.$t('stigler_popup.item_5.content_9'), className: "" },
              { label: this.$t('stigler_popup.label_10'), content: this.$t('stigler_popup.item_5.content_10'), className: "" },
            ],
            des: [
              { label: this.$t('stigler_popup.label_11'), content: this.$t('stigler_popup.item_5.content_11'), className: "" },
              { label: this.$t('stigler_popup.label_12'), content: this.$t('stigler_popup.item_5.content_12'), className: "" },
              { label: this.$t('stigler_popup.label_13'), content: this.$t('stigler_popup.item_5.content_13'), className: "" },
            ]
          },
          {
            title: this.$t('stigler_popup.item_6.title'),
            image: require('@/assets/img/stigler/805.png'),
            download: './doc/葡萄酒彩页.pdf',
            info: [
              { label: this.$t('stigler_popup.label_1'), content: this.$t('stigler_popup.item_6.content_1'), className: "" },
              { label: this.$t('stigler_popup.label_2'), content: this.$t('stigler_popup.item_6.content_2'), className: "" },
              { label: this.$t('stigler_popup.label_3'), content: this.$t('stigler_popup.item_6.content_3'), className: "" },
              { label: this.$t('stigler_popup.label_4'), content: this.$t('stigler_popup.item_6.content_4'), className: "" },
              { label: this.$t('stigler_popup.label_5'), content: this.$t('stigler_popup.item_6.content_5'), className: "" },
              { label: this.$t('stigler_popup.label_6'), content: this.$t('stigler_popup.item_6.content_6'), className: "" },
              { label: this.$t('stigler_popup.label_7'), content: this.$t('stigler_popup.item_6.content_7'), className: "" },
            ],
            alcohol:[
              { label: this.$t('stigler_popup.label_8'), content: this.$t('stigler_popup.item_6.content_8'), className: "" },
              { label: this.$t('stigler_popup.label_9'), content: this.$t('stigler_popup.item_6.content_9'), className: "" },
              { label: this.$t('stigler_popup.label_10'), content: this.$t('stigler_popup.item_6.content_10'), className: "" },
            ],
            des: [
              { label: this.$t('stigler_popup.label_11'), content: this.$t('stigler_popup.item_6.content_11'), className: "" },
              { label: this.$t('stigler_popup.label_12'), content: this.$t('stigler_popup.item_6.content_12'), className: "" },
              { label: this.$t('stigler_popup.label_13'), content: this.$t('stigler_popup.item_6.content_13'), className: "" },
            ]
          },
          {
            title: this.$t('stigler_popup.item_7.title'),
            image: require('@/assets/img/stigler/310.png'),
            download: './doc/葡萄酒彩页.pdf',
            info: [
              { label: this.$t('stigler_popup.label_1'), content: this.$t('stigler_popup.item_7.content_1'), className: "" },
              { label: this.$t('stigler_popup.label_2'), content: this.$t('stigler_popup.item_7.content_2'), className: "" },
              { label: this.$t('stigler_popup.label_3'), content: this.$t('stigler_popup.item_7.content_3'), className: "" },
              { label: this.$t('stigler_popup.label_4'), content: this.$t('stigler_popup.item_7.content_4'), className: "" },
              { label: this.$t('stigler_popup.label_5'), content: this.$t('stigler_popup.item_7.content_5'), className: "" },
              { label: this.$t('stigler_popup.label_6'), content: this.$t('stigler_popup.item_7.content_6'), className: "" },
              { label: this.$t('stigler_popup.label_7'), content: this.$t('stigler_popup.item_7.content_7'), className: "" },
            ],
            alcohol:[
              { label: this.$t('stigler_popup.label_8'), content: this.$t('stigler_popup.item_7.content_8'), className: "" },
              { label: this.$t('stigler_popup.label_9'), content: this.$t('stigler_popup.item_7.content_9'), className: "" },
              { label: this.$t('stigler_popup.label_10'), content: this.$t('stigler_popup.item_7.content_10'), className: "" },
            ],
            des: [
              { label: this.$t('stigler_popup.label_11'), content: this.$t('stigler_popup.item_7.content_11'), className: "" },
              { label: this.$t('stigler_popup.label_12'), content: this.$t('stigler_popup.item_7.content_12'), className: "" },
              { label: this.$t('stigler_popup.label_13'), content: this.$t('stigler_popup.item_7.content_13'), className: "" },
            ]
          },
          {
            title: this.$t('stigler_popup.item_8.title'),
            image: require('@/assets/img/stigler/709.png'),
            download: './doc/葡萄酒彩页.pdf',
            info: [
              { label: this.$t('stigler_popup.label_1'), content: this.$t('stigler_popup.item_8.content_1'), className: "" },
              { label: this.$t('stigler_popup.label_2'), content: this.$t('stigler_popup.item_8.content_2'), className: "" },
              { label: this.$t('stigler_popup.label_3'), content: this.$t('stigler_popup.item_8.content_3'), className: "" },
              { label: this.$t('stigler_popup.label_4'), content: this.$t('stigler_popup.item_8.content_4'), className: "" },
              { label: this.$t('stigler_popup.label_5'), content: this.$t('stigler_popup.item_8.content_5'), className: "" },
              { label: this.$t('stigler_popup.label_6'), content: this.$t('stigler_popup.item_8.content_6'), className: "" },
              { label: this.$t('stigler_popup.label_7'), content: this.$t('stigler_popup.item_8.content_7'), className: "" },
            ],
            alcohol:[
              { label: this.$t('stigler_popup.label_8'), content: this.$t('stigler_popup.item_8.content_8'), className: "" },
              { label: this.$t('stigler_popup.label_9'), content: this.$t('stigler_popup.item_8.content_9'), className: "" },
              { label: this.$t('stigler_popup.label_10'), content: this.$t('stigler_popup.item_8.content_10'), className: "" },
            ],
            des: [
              { label: this.$t('stigler_popup.label_11'), content: this.$t('stigler_popup.item_8.content_11'), className: "" },
              { label: this.$t('stigler_popup.label_12'), content: this.$t('stigler_popup.item_8.content_12'), className: "" },
              { label: this.$t('stigler_popup.label_13'), content: this.$t('stigler_popup.item_8.content_13'), className: "" },
            ]
          },
          {
            title: this.$t('stigler_popup.item_9.title'),
            image: require('@/assets/img/stigler/508.png'),
            download: './doc/葡萄酒彩页.pdf',
            info: [
              { label: this.$t('stigler_popup.label_1'), content: this.$t('stigler_popup.item_9.content_1'), className: "" },
              { label: this.$t('stigler_popup.label_2'), content: this.$t('stigler_popup.item_9.content_2'), className: "" },
              { label: this.$t('stigler_popup.label_3'), content: this.$t('stigler_popup.item_9.content_3'), className: "" },
              { label: this.$t('stigler_popup.label_4'), content: this.$t('stigler_popup.item_9.content_4'), className: "" },
              { label: this.$t('stigler_popup.label_5'), content: this.$t('stigler_popup.item_9.content_5'), className: "" },
              { label: this.$t('stigler_popup.label_6'), content: this.$t('stigler_popup.item_9.content_6'), className: "" },
              { label: this.$t('stigler_popup.label_7'), content: this.$t('stigler_popup.item_9.content_7'), className: "" },
            ],
            alcohol:[
              { label: this.$t('stigler_popup.label_8'), content: this.$t('stigler_popup.item_9.content_8'), className: "" },
              { label: this.$t('stigler_popup.label_9'), content: this.$t('stigler_popup.item_9.content_9'), className: "" },
              { label: this.$t('stigler_popup.label_10'), content: this.$t('stigler_popup.item_9.content_10'), className: "" },
            ],
            des: [
              { label: this.$t('stigler_popup.label_11'), content: this.$t('stigler_popup.item_9.content_11'), className: "" },
              { label: this.$t('stigler_popup.label_12'), content: this.$t('stigler_popup.item_9.content_12'), className: "" },
              { label: this.$t('stigler_popup.label_13'), content: this.$t('stigler_popup.item_9.content_13'), className: "" },
            ]
          },
          {
            title: this.$t('stigler_popup.item_10.title'),
            image: require('@/assets/img/stigler/408.png'),
            download: './doc/葡萄酒彩页.pdf',
            info: [
              { label: this.$t('stigler_popup.label_1'), content: this.$t('stigler_popup.item_10.content_1'), className: "" },
              { label: this.$t('stigler_popup.label_2'), content: this.$t('stigler_popup.item_10.content_2'), className: "" },
              { label: this.$t('stigler_popup.label_3'), content: this.$t('stigler_popup.item_10.content_3'), className: "" },
              { label: this.$t('stigler_popup.label_4'), content: this.$t('stigler_popup.item_10.content_4'), className: "" },
              { label: this.$t('stigler_popup.label_5'), content: this.$t('stigler_popup.item_10.content_5'), className: "" },
              { label: this.$t('stigler_popup.label_6'), content: this.$t('stigler_popup.item_10.content_6'), className: "" },
              { label: this.$t('stigler_popup.label_7'), content: this.$t('stigler_popup.item_10.content_7'), className: "" },
            ],
            alcohol:[
              { label: this.$t('stigler_popup.label_8'), content: this.$t('stigler_popup.item_10.content_8'), className: "" },
              { label: this.$t('stigler_popup.label_9'), content: this.$t('stigler_popup.item_10.content_9'), className: "" },
              { label: this.$t('stigler_popup.label_10'), content: this.$t('stigler_popup.item_10.content_10'), className: "" },
            ],
            des: [
              { label: this.$t('stigler_popup.label_11'), content: this.$t('stigler_popup.item_10.content_11'), className: "" },
              { label: this.$t('stigler_popup.label_12'), content: this.$t('stigler_popup.item_10.content_12'), className: "" },
              { label: this.$t('stigler_popup.label_13'), content: this.$t('stigler_popup.item_10.content_13'), className: "" },
            ]
          },
          {
            title: this.$t('stigler_popup.item_11.title'),
            image: require('@/assets/img/stigler/308.png'),
            download: './doc/葡萄酒彩页.pdf',
            info: [
              { label: this.$t('stigler_popup.label_1'), content: this.$t('stigler_popup.item_11.content_1'), className: "" },
              { label: this.$t('stigler_popup.label_2'), content: this.$t('stigler_popup.item_11.content_2'), className: "" },
              { label: this.$t('stigler_popup.label_3'), content: this.$t('stigler_popup.item_11.content_3'), className: "" },
              { label: this.$t('stigler_popup.label_4'), content: this.$t('stigler_popup.item_11.content_4'), className: "" },
              { label: this.$t('stigler_popup.label_5'), content: this.$t('stigler_popup.item_11.content_5'), className: "" },
              { label: this.$t('stigler_popup.label_6'), content: this.$t('stigler_popup.item_11.content_6'), className: "" },
              { label: this.$t('stigler_popup.label_7'), content: this.$t('stigler_popup.item_11.content_7'), className: "" },
            ],
            alcohol:[
              { label: this.$t('stigler_popup.label_8'), content: this.$t('stigler_popup.item_11.content_8'), className: "" },
              { label: this.$t('stigler_popup.label_9'), content: this.$t('stigler_popup.item_11.content_9'), className: "" },
              { label: this.$t('stigler_popup.label_10'), content: this.$t('stigler_popup.item_11.content_10'), className: "" },
            ],
            des: [
              { label: this.$t('stigler_popup.label_11'), content: this.$t('stigler_popup.item_11.content_11'), className: "" },
              { label: this.$t('stigler_popup.label_12'), content: this.$t('stigler_popup.item_11.content_12'), className: "" },
              { label: this.$t('stigler_popup.label_13'), content: this.$t('stigler_popup.item_11.content_13'), className: "" },
            ]
          },
        ],
      }
    },
    computed: {},
    watch: {
      content(data) {
        this.param = data
        console.log(this.param)
      }
    },
    methods:{
      stopPropagation(e){
        if (e.stopPropagation) {
          e.stopPropagation();
        } else {
          e.cancelBubble = true;
        }
      },
      prevPage(){
        this.param.index -= 1
      },
      nextPage(){
        this.param.index += 1
      }
    },
    created(){}
  }
</script>
